import React, { useState } from 'react'
import { motion } from "framer-motion/dist/framer-motion";
import {
  
  staticBounceVariants
} from "shared/components/animations";
const JokeCard = ({joke}) => {
  return (
    <motion.div variants={staticBounceVariants}
    initial="hidden"
    animate="visible"
    exit="exit" className='joke-box'>
      <p className='joke'>{joke}</p>
     <p className='author'>~Annoying Person</p> 
    </motion.div>
  )
}

export default JokeCard;